import {
  aSumoSearchHistogramBucket,
  aSumoSearchJobStatus,
  aSumoSearchObjectTypeCount,
  mockRecordSearchResultsOperationQuery,
  SumoSearchJobState,
} from '__generated__';

import { RECORDS_JSON } from '@sbu/configs.mocks';

export const handlers = [
  mockRecordSearchResultsOperationQuery((_req, res, ctx) => {
    const { jobId } = _req.variables;
    const results =
      jobId === '1' ? RECORDS_JSON.map((record) => JSON.stringify(record)) : [];
    const objectTypeCountsOverrides = results.length
      ? {
          count: 2,
          objectType: 'NetworkProxy',
        }
      : {
          count: 0,
        };
    const jobStatusOverrides = results.length
      ? {
          histogramBuckets: [aSumoSearchHistogramBucket()],
          state: SumoSearchJobState.DoneGatheringResults,
        }
      : { state: SumoSearchJobState.DoneGatheringResults };

    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        sumoRecordSearchJobObjectTypeCounts: [
          aSumoSearchObjectTypeCount(objectTypeCountsOverrides),
        ],
        sumoRecordSearchJobResults: results,
        sumoRecordSearchJobStatus: aSumoSearchJobStatus(jobStatusOverrides),
      })
    );
  }),
];
